const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/field/history.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/field/history.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { FieldLogListPendingState } from '@/features/field-log/components/FieldLogListPendingState';
import { FIELD_LOG_HISTORY_PAGE_LIMIT } from '@/features/field-log/config/constants';
import { fieldLogHistorySearchSchema } from '@/features/field-log/lib/historySearch';
import { fieldLogVisitsQuery } from '@/features/field-log/services/fieldLogQueries';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/field/history')({
  validateSearch: fieldLogHistorySearchSchema,
  loaderDeps: ({
    search
  }) => search,
  loader: ({
    context,
    deps
  }) => context.queryClient.ensureInfiniteQueryData(fieldLogVisitsQuery(deps, FIELD_LOG_HISTORY_PAGE_LIMIT)),
  pendingComponent: FieldLogListPendingState,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});